import React, { useEffect } from "react";
import { Row, Col, Badge, Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { useParams, useNavigate } from "react-router-dom";
import { styles } from "./blogStyles";
import axios from "axios";
import { API_URL } from "../../utils/Url";
import { useState } from "react";

const SingleBlog = () => {
  const params = useParams();

  const slug = params.id;
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [latestBlogs, setLatestBlogs] = useState([]);
  //   const blog = blog.find((b) => b.slug === slug);

  //   const sidebarBlogs = latestBlogs.filter((b) => b.slug !== slug).slice(0, 5);

  const getSingleBlog = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/api/blog/get_single/${slug}`,
      );

      setBlog(data.blog);
    } catch (error) {
      console.log(error);
    }
  };
  const getLatestBlog = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/blog/get_latest_blogs`);

      setLatestBlogs(data.blogs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSingleBlog();
    getLatestBlog();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);
  // console.log(blog, "blog");
  if (!blog) {
    return (
      <div style={styles?.pageBackground} className="text-center py-5">
        <h2 className="text-white my-5">Article Not Found</h2>
        <button onClick={() => navigate("/blogs")} style={styles?.backButton}>
          Back to Articles
        </button>
      </div>
    );
  }
  return (
    <>
      {/* <Helmet prioritizeSeoTags>
        <meta
          name="keywords"
          content="Vishnu Ji Maharaj, Bhakti Katha, Sanatan Dharma, Spiritual Stories, Hindu Dharma, Krishna Katha, Jagannath Katha, Devotional Content"
        />
        <title>{`${blog.title} | Vishnu Ji Maharaj`}</title>
        <meta name="description" content={blog?.metaDescription} />
        <link
          rel="canonical"
          href={`https://vishnujimaharaj.com/blog/${slug}`}
        />

        <meta property="og:type" content="article" />
        <meta property="og:title" content={blog?.title} />
        <meta property="og:description" content={blog?.metaDescription} />
        <meta property="og:image" content={blog?.image} />
        <meta
          property="og:url"
          content={`https://vishnujimaharaj.com/blog/${slug}`}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog?.title} />
        <meta name="twitter:description" content={blog?.metaDescription} />
        <meta name="twitter:image" content={blog?.image} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://vishnujimaharaj.com",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blog",
                item: "https://vishnujimaharaj.com/blog",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: blog?.title,
                item: `https://vishnujimaharaj.com/blog/${slug}`,
              },
            ],
          })}
        </script>
      </Helmet> */}

      <div style={styles?.pageBackground}>
        {/* Background Neon Blobs for attractive premium layout */}
        <div style={styles?.neonBlob1}></div>
        <div style={styles?.neonBlob2}></div>

        <Container className="py-4" style={{ position: "relative", zIndex: 2 }}>
          {/* Back Button to Grid View via Router path */}
          <motion.button
            whileHover={{ x: -4 }}
            onClick={() => navigate("/blog")}
            style={styles?.backButton}
            className="mb-4"
          >
            &larr; Back to Articles
          </motion.button>

          <Row className="g-2">
            {/* LEFT AREA: Full article reader block */}
            <Col xs={12} lg={12}>
              <motion.article
                style={styles?.articleContainer}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div style={styles?.articleHeaderImageWrapper}>
                  <img
                    src={blog?.blogImage?.url}
                    alt={blog?.title}
                    style={styles?.articleImg}
                  />
                  <Badge
                    style={{
                      ...styles?.articleBadge,
                      background: blog?.gradient,
                    }}
                  >
                    {blog?.category}
                  </Badge>
                </div>

                <div
                  className="d-flex gap-3 text-muted my-3"
                  style={{ fontSize: "0.9rem" }}
                >
                  {/* <span>
                    Published: <b>{blog.date}</b>
                  </span>
                  <span>•</span>
                  <span>{blog.readTime}</span> */}
                </div>

                <h1 style={styles?.articleMainTitle}>{blog?.title}</h1>

                <hr
                  style={{
                    borderColor: "rgba(255,255,255,0.15)",
                    margin: "25px 0",
                  }}
                />

                {/* <p style={styles?.articleParagraph} className="lead">
                  {blog.metaDescription}
                </p> */}

                {/* ================= INLINE HIGH-END RESPONSIVE CSS INJECTOR ================= */}
                <style>
                  {`
                    .premium-html-content img {
                      width: 600px !important;
                      height: 400px !important;
                      
                      border-radius: 16px !important;
                      margin-top: 15px !important;
                      margin-bottom: 15px !important;
                      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4) !important;
                      transition: transform 0.3s ease !important;
                    }
                    .premium-html-content img:hover {
                      transform: scale(1.01) !important;
                    }
                    @media (max-width: 768px) {
                      .premium-html-content img {
                        height: 220px !important; /* Mobile screen logic */
                      }
                    }
                  `}
                </style>

                <div
                  className="premium-html-content"
                  style={styles.articleContentHtml}
                  dangerouslySetInnerHTML={{
                    __html:
                      blog?.description?.replace(
                        /<p>\s*(<br\s*\/?>)?\s*<\/p>/gi,
                        "",
                      ) || "",
                  }}
                />
              </motion.article>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SingleBlog;
